import { IOfferDescriptionVisualParameter } from "./IOfferDescriptionVisualParameter";
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 12.04.13
 * Time: 17:34
 */

import { BasicPrivateOfferVO } from "../../BasicPrivateOfferVO";
import { Constants_Offer } from "../../Constants_Offer";
import { PrivateOfferStateEnum } from "../../PrivateOfferStateEnum";

/**
 * Visual parameter to visualize the offer as iso object in the foreground of the castle
 */
export class OfferDescriptionVisualIsoObject implements IOfferDescriptionVisualParameter {
    private _objectType: string;
    private _objectName: string;
    private _areaTypes: any[];
    private _isVisible: boolean = false;

    constructor(objectType: string, objectName: string, areaTypes: any[], isVisible: boolean) {
        this._objectType = objectType;
        this._objectName = objectName;
        this._areaTypes = areaTypes;
        this._isVisible = isVisible;
    }

    public get name(): string {
        return Constants_Offer.OFFER_VISUAL_ISO_OBJECT;
    }

    public parseFromObjectParam(params: any): void {
        this._objectType = params.OT;
        this._objectName = params.ON;
        this._areaTypes = params.ATS;
        this._isVisible = false;
    }

    public execute(offerVO: BasicPrivateOfferVO): boolean {
        // make iso object visible if quest or offer is running
        if (offerVO.offerState === PrivateOfferStateEnum.QUEST_STARTED || offerVO.offerState === PrivateOfferStateEnum.QUEST_PENDING || offerVO.offerState === PrivateOfferStateEnum.OFFER_READY || offerVO.offerState === PrivateOfferStateEnum.OFFER_PENDING) {
            if (!this._isVisible) {
                this._isVisible = true;

                if (!this.executeVisibleHook()) {
                    return false;
                }
            }
        }
        else {
            if (this._isVisible) {
                this._isVisible = false;

                if (!this.executeInvisibleHook()) {
                    return false;
                }
            }
        }
        return true;
    }

    protected executeVisibleHook(): boolean {
        // can be override
        return true;
    }

    protected executeInvisibleHook(): boolean {
        // can be override
        return true;
    }

    public toExecuteInState(state: PrivateOfferStateEnum): boolean {
        return true; // execute for every state change, to also delete building if offer comes into finish state
    }

    /**
     * Checks if the iso object is visible in this area
     * @param areaType
     * @return
     */
    public isIsoObjectVisibleByArea(areaType: number): boolean {
        return this._areaTypes ? this._areaTypes.indexOf(areaType) > -1 : true;
    }

    public get objectType(): string {
        return this._objectType;
    }

    public get objectName(): string {
        return this._objectName;
    }

    public get areaTypes(): any[] {
        return this._areaTypes;
    }

    public get isVisible(): boolean {
        return this._isVisible;
    }

    public dispose(): void {
        this._objectType = null;
        this._objectName = null;
    }

    public getCommandName(): string {
        return "PRIVATE_OFFER_VISUAL_ISO_OBJECT";
    }
}

